const BREAKPOINTS = {
  xs: "375px",
  sm: "768px",
  md: "1024px",
  lg: "1280px",
  xl: "1440px",
  xxl: "1728px"
};
const STATIC_TOKENS = {
  dimension: {
    space: {
      "1": "--kindred-dimension-space-1",
      "2": "--kindred-dimension-space-2",
      "3": "--kindred-dimension-space-3",
      "4": "--kindred-dimension-space-4",
      "5": "--kindred-dimension-space-5",
      "6": "--kindred-dimension-space-6",
      "8": "--kindred-dimension-space-8",
      "10": "--kindred-dimension-space-10",
      "12": "--kindred-dimension-space-12",
      "16": "--kindred-dimension-space-16",
      "20": "--kindred-dimension-space-20",
      "24": "--kindred-dimension-space-24"
    }
  },
  text: {
    fontSize: {
      "10": "--kindred-text-font-size-10",
      "11": "--kindred-text-font-size-11",
      "12": "--kindred-text-font-size-12",
      "14": "--kindred-text-font-size-14",
      "16": "--kindred-text-font-size-16",
      "18": "--kindred-text-font-size-18",
      "20": "--kindred-text-font-size-20",
      "21": "--kindred-text-font-size-21",
      "22": "--kindred-text-font-size-22",
      "24": "--kindred-text-font-size-24",
      "28": "--kindred-text-font-size-28",
      "32": "--kindred-text-font-size-32",
      "36": "--kindred-text-font-size-36",
      "40": "--kindred-text-font-size-40",
      "44": "--kindred-text-font-size-44",
      "48": "--kindred-text-font-size-48",
      "52": "--kindred-text-font-size-52",
      "56": "--kindred-text-font-size-56",
      "64": "--kindred-text-font-size-64"
    }
  }
};
const STATIC_VALUES = {
  dimension: {
    space: {
      "1": "4px",
      "2": "8px",
      "3": "12px",
      "4": "16px",
      "5": "20px",
      "6": "24px",
      "8": "32px",
      "10": "40px",
      "12": "48px",
      "16": "64px",
      "20": "80px",
      "24": "96px"
    }
  },
  text: {
    fontSize: {
      "10": "10",
      "11": "11",
      "12": "12",
      "14": "14",
      "16": "16",
      "18": "18",
      "20": "20",
      "21": "21",
      "22": "22",
      "24": "24",
      "28": "28",
      "32": "32",
      "36": "36",
      "40": "40",
      "44": "44",
      "48": "48",
      "52": "52",
      "56": "56",
      "64": "64"
    }
  }
};
const SEMANTIC_TOKENS = {
  color: {
    foreground: {
      default: "--kindred-color-foreground-default",
      subdued: "--kindred-color-foreground-subdued",
      onNavigation: "--kindred-color-foreground-on-navigation",
      primary: "--kindred-color-foreground-primary",
      interaction: {
        onAccent: "--kindred-color-foreground-interaction-on-accent",
        onSelected: "--kindred-color-foreground-interaction-on-selected",
        disabled: "--kindred-color-foreground-interaction-disabled",
        onDisabled: "--kindred-color-foreground-interaction-on-disabled",
        accent: "--kindred-color-foreground-interaction-accent",
        accentHover: "--kindred-color-foreground-interaction-accent-hover",
        accentActive: "--kindred-color-foreground-interaction-accent-active",
        onReverse: "--kindred-color-foreground-interaction-on-reverse",
        onReverseHover: "--kindred-color-foreground-interaction-on-reverse-hover",
        onReverseActive: "--kindred-color-foreground-interaction-on-reverse-active",
        onFeedback: "--kindred-color-foreground-interaction-on-feedback",
        onFeedbackHover: "--kindred-color-foreground-interaction-on-feedback-hover",
        onFeedbackActive: "--kindred-color-foreground-interaction-on-feedback-active",
        onAccentSubdued: "--kindred-color-foreground-interaction-on-accent-subdued",
        onDanger: "--kindred-color-foreground-interaction-on-danger",
        dangerHover: "--kindred-color-foreground-interaction-danger-hover",
        dangerActive: "--kindred-color-foreground-interaction-danger-active"
      },
      feedback: {
        success: "--kindred-color-foreground-feedback-success",
        warning: "--kindred-color-foreground-feedback-warning",
        danger: "--kindred-color-foreground-feedback-danger",
        info: "--kindred-color-foreground-feedback-info"
      },
      series: {
        onData01: "--kindred-color-foreground-series-on-data-01",
        onData02: "--kindred-color-foreground-series-on-data-02",
        onData03: "--kindred-color-foreground-series-on-data-03",
        onData04: "--kindred-color-foreground-series-on-data-04",
        onData05: "--kindred-color-foreground-series-on-data-05",
        onData06: "--kindred-color-foreground-series-on-data-06",
        onData07: "--kindred-color-foreground-series-on-data-07",
        onData08: "--kindred-color-foreground-series-on-data-08",
        onData09: "--kindred-color-foreground-series-on-data-09",
        onData10: "--kindred-color-foreground-series-on-data-10",
        onData11: "--kindred-color-foreground-series-on-data-11",
        onData12: "--kindred-color-foreground-series-on-data-12",
        onData13: "--kindred-color-foreground-series-on-data-13",
        onData14: "--kindred-color-foreground-series-on-data-14"
      }
    },
    background: {
      surface0: "--kindred-color-background-surface-0",
      surface1: "--kindred-color-background-surface-1",
      surface2: "--kindred-color-background-surface-2",
      surface3: "--kindred-color-background-surface-3",
      application: "--kindred-color-background-application",
      reverse: "--kindred-color-background-reverse",
      surfaceOverlay: "--kindred-color-background-surface-overlay",
      surfaceObscure: "--kindred-color-background-surface-obscure",
      navigation: "--kindred-color-background-navigation",
      interaction: {
        accent: "--kindred-color-background-interaction-accent",
        accentHover: "--kindred-color-background-interaction-accent-hover",
        accentActive: "--kindred-color-background-interaction-accent-active",
        transparent: "--kindred-color-background-interaction-transparent",
        accentSubdued: "--kindred-color-background-interaction-accent-subdued",
        accentSubduedHover: "--kindred-color-background-interaction-accent-subdued-hover",
        accentSubduedActive: "--kindred-color-background-interaction-accent-subdued-active",
        danger: "--kindred-color-background-interaction-danger",
        dangerHover: "--kindred-color-background-interaction-danger-hover",
        dangerActive: "--kindred-color-background-interaction-danger-active",
        disabled: "--kindred-color-background-interaction-disabled",
        neutral: "--kindred-color-background-interaction-neutral",
        neutralHover: "--kindred-color-background-interaction-neutral-hover",
        neutralActive: "--kindred-color-background-interaction-neutral-active",
        neutralSelected: "--kindred-color-background-interaction-neutral-selected",
        neutralSelectedHover: "--kindred-color-background-interaction-neutral-selected-hover",
        neutralActivated: "--kindred-color-background-interaction-neutral-activated",
        neutralUnactivated: "--kindred-color-background-interaction-neutral-unactivated",
        neutralEmphasized: "--kindred-color-background-interaction-neutral-emphasized",
        neutralEmphasizedHover: "--kindred-color-background-interaction-neutral-emphasized-hover",
        neutralDisabled: "--kindred-color-background-interaction-neutral-disabled",
        dangerSubduedHover: "--kindred-color-background-interaction-danger-subdued-hover",
        dangerSubduedActive: "--kindred-color-background-interaction-danger-subdued-active",
        dangerSelected: "--kindred-color-background-interaction-danger-selected"
      },
      feedback: {
        info: "--kindred-color-background-feedback-info",
        success: "--kindred-color-background-feedback-success",
        warning: "--kindred-color-background-feedback-warning",
        danger: "--kindred-color-background-feedback-danger",
        infoStrong: "--kindred-color-background-feedback-info-strong",
        successStrong: "--kindred-color-background-feedback-success-strong",
        warningStrong: "--kindred-color-background-feedback-warning-strong",
        dangerStrong: "--kindred-color-background-feedback-danger-strong"
      },
      series: {
        data01: "--kindred-color-background-series-data-01",
        data02: "--kindred-color-background-series-data-02",
        data03: "--kindred-color-background-series-data-03",
        data04: "--kindred-color-background-series-data-04",
        data05: "--kindred-color-background-series-data-05",
        data06: "--kindred-color-background-series-data-06",
        data07: "--kindred-color-background-series-data-07",
        data08: "--kindred-color-background-series-data-08",
        data09: "--kindred-color-background-series-data-09",
        data10: "--kindred-color-background-series-data-10",
        data11: "--kindred-color-background-series-data-11",
        data12: "--kindred-color-background-series-data-12",
        data13: "--kindred-color-background-series-data-13",
        data14: "--kindred-color-background-series-data-14"
      }
    },
    border: {
      default: "--kindred-color-border-default",
      brand: "--kindred-color-border-brand",
      onColor: "--kindred-color-border-on-color",
      subtle: "--kindred-color-border-subtle",
      focus: "--kindred-color-border-focus",
      focusDanger: "--kindred-color-border-focus-danger",
      navigation: "--kindred-color-border-navigation",
      interaction: {
        accent: "--kindred-color-border-interaction-accent",
        accentHover: "--kindred-color-border-interaction-accent-hover",
        accentActive: "--kindred-color-border-interaction-accent-active",
        accentDisabled: "--kindred-color-border-interaction-accent-disabled",
        danger: "--kindred-color-border-interaction-danger",
        neutral: "--kindred-color-border-interaction-neutral",
        neutralHover: "--kindred-color-border-interaction-neutral-hover",
        neutralActive: "--kindred-color-border-interaction-neutral-active",
        neutralSelected: "--kindred-color-border-interaction-neutral-selected",
        neutralEmphasized: "--kindred-color-border-interaction-neutral-emphasized"
      },
      feedback: {
        success: "--kindred-color-border-feedback-success",
        warning: "--kindred-color-border-feedback-warning",
        danger: "--kindred-color-border-feedback-danger",
        info: "--kindred-color-border-feedback-info"
      }
    }
  },
  dimension: {
    borderWidth: {
      division: "--kindred-dimension-border-width-division",
      interaction: "--kindred-dimension-border-width-interaction",
      focus: "--kindred-dimension-border-width-focus",
      selection: "--kindred-dimension-border-width-selection"
    },
    radius: {
      surface0: "--kindred-dimension-radius-surface-0",
      surface1: "--kindred-dimension-radius-surface-1",
      surface2: "--kindred-dimension-radius-surface-2",
      surface3: "--kindred-dimension-radius-surface-3",
      surface4: "--kindred-dimension-radius-surface-4",
      surfaceRound: "--kindred-dimension-radius-surface-round",
      interaction: {
        action: "--kindred-dimension-radius-interaction-action",
        actionFocus: "--kindred-dimension-radius-interaction-action-focus",
        inputSmall: "--kindred-dimension-radius-interaction-input-small",
        inputSmallFocus: "--kindred-dimension-radius-interaction-input-small-focus",
        inputLarge: "--kindred-dimension-radius-interaction-input-large",
        inputLargeFocus: "--kindred-dimension-radius-interaction-input-large-focus"
      }
    }
  },
  shadow: {
    level1: {
      bright: {
        offsetX: "--kindred-shadow-level1-bright-offset-x",
        offsetY: "--kindred-shadow-level1-bright-offset-y",
        blurRadius: "--kindred-shadow-level1-bright-blur-radius",
        spreadRadius: "--kindred-shadow-level1-bright-spread-radius",
        color: "--kindred-shadow-level1-bright-color"
      },
      dim: {
        offsetX: "--kindred-shadow-level1-dim-offset-x",
        offsetY: "--kindred-shadow-level1-dim-offset-y",
        blurRadius: "--kindred-shadow-level1-dim-blur-radius",
        spreadRadius: "--kindred-shadow-level1-dim-spread-radius",
        color: "--kindred-shadow-level1-dim-color"
      }
    },
    level2: {
      bright: {
        offsetX: "--kindred-shadow-level2-bright-offset-x",
        offsetY: "--kindred-shadow-level2-bright-offset-y",
        blurRadius: "--kindred-shadow-level2-bright-blur-radius",
        spreadRadius: "--kindred-shadow-level2-bright-spread-radius",
        color: "--kindred-shadow-level2-bright-color"
      },
      dim: {
        offsetX: "--kindred-shadow-level2-dim-offset-x",
        offsetY: "--kindred-shadow-level2-dim-offset-y",
        blurRadius: "--kindred-shadow-level2-dim-blur-radius",
        spreadRadius: "--kindred-shadow-level2-dim-spread-radius",
        color: "--kindred-shadow-level2-dim-color"
      }
    },
    level3: {
      dim: {
        offsetX: "--kindred-shadow-level3-dim-offset-x",
        offsetY: "--kindred-shadow-level3-dim-offset-y",
        blurRadius: "--kindred-shadow-level3-dim-blur-radius",
        spreadRadius: "--kindred-shadow-level3-dim-spread-radius",
        color: "--kindred-shadow-level3-dim-color"
      }
    },
    level4: {
      bright: {
        offsetX: "--kindred-shadow-level4-bright-offset-x",
        offsetY: "--kindred-shadow-level4-bright-offset-y",
        blurRadius: "--kindred-shadow-level4-bright-blur-radius",
        spreadRadius: "--kindred-shadow-level4-bright-spread-radius",
        color: "--kindred-shadow-level4-bright-color"
      },
      dim: {
        offsetX: "--kindred-shadow-level4-dim-offset-x",
        offsetY: "--kindred-shadow-level4-dim-offset-y",
        blurRadius: "--kindred-shadow-level4-dim-blur-radius",
        spreadRadius: "--kindred-shadow-level4-dim-spread-radius",
        color: "--kindred-shadow-level4-dim-color"
      }
    }
  },
  text: {
    fontFamily: {
      primary: "--kindred-text-font-family-primary",
      accent: "--kindred-text-font-family-accent",
      tertiary: "--kindred-text-font-family-tertiary",
      signature: "--kindred-text-font-family-signature"
    },
    fontWeight: {
      headline: "--kindred-text-font-weight-headline",
      header: "--kindred-text-font-weight-header",
      default: "--kindred-text-font-weight-default",
      label: "--kindred-text-font-weight-label",
      hyperlink: "--kindred-text-font-weight-hyperlink",
      disclaimer: "--kindred-text-font-weight-disclaimer",
      action: "--kindred-text-font-weight-action"
    },
    letterSpacing: {
      default: "--kindred-text-letter-spacing-default",
      headlineLarge: "--kindred-text-letter-spacing-headline-large",
      headlineMedium: "--kindred-text-letter-spacing-headline-medium",
      headlineSmall: "--kindred-text-letter-spacing-headline-small",
      headlineXsmall: "--kindred-text-letter-spacing-headline-xsmall",
      headerXlarge: "--kindred-text-letter-spacing-header-xlarge",
      headerLarge: "--kindred-text-letter-spacing-header-large",
      label: "--kindred-text-letter-spacing-label"
    }
  },
  logo: {
    brand: "--kindred-logo-brand"
  }
};
const TOKENS = {
  ...SEMANTIC_TOKENS,
  dimension: {
    ...SEMANTIC_TOKENS.dimension,
    space: STATIC_TOKENS.dimension.space
  },
  text: {
    ...SEMANTIC_TOKENS.text,
    fontSize: STATIC_TOKENS.text.fontSize
  }
};
const fontSizeRem = (px) => `calc(var(${TOKENS.text.fontSize[px]}) / 16 * 1rem)`;
export {
  BREAKPOINTS as B,
  SEMANTIC_TOKENS as S,
  TOKENS as T,
  STATIC_VALUES as a,
  STATIC_TOKENS as b,
  fontSizeRem as f
};
